import ServiceOverlay, { LocationType } from "@churchofjesuschrist/maps-google-service-overlay";
import { polygonsMask } from "@churchofjesuschrist/maps-google-overlays";

export default function AppController($rootScope, $timeout, $scope, $win, $state, google, utils, DataService, UserService, NotificationService) {
	"ngInject";

	const vm = this;

	vm.$onInit = () => {
		vm.missionId = $state.params.missionId;

		if (vm.missionId) {
			vm.loadMission();
		} else {
			UserService.getUserMission().then((mission) => {
				if (mission && mission.id) {
					$state.go($state.current.name, {missionId: mission.id});
				} else {
					NotificationService.error("pros-maps.error.selected", null, mission);
				}
			});
		}


		$scope.$on("$stateChangeStart", vm.clearSelected);

		$win.on("resize", vm.resize);
		$scope.$on("$destroy", () => {
			$win.off("resize", vm.resize);
		});
	};

	vm.onLoad = () => {
		if (vm.mission && vm.map) {
			let bounds = utils.getOrgBounds(vm.mission);
			if (bounds && (!vm.previousBounds || vm.previousBounds.equals(vm.map.getBounds()))) {
				vm.map.fitBounds(bounds);
				vm.previousBounds = vm.map.getBounds();
			}

			let boundary = utils.getOrgBoundary(vm.mission);
			if (boundary) {
				if (vm.mask) {
					vm.mask.setMap(null);
				}
				vm.mask = polygonsMask(boundary, {map: vm.map});
			}

			if (!vm.overlay) {
				vm.overlay = new ServiceOverlay({layers: LocationType.MISSION, zIndex: 1, map: vm.map});
			}
		}
	};

	vm.loadMission = () => {
		DataService.loadMission(vm.missionId).then((mission) => {
			vm.mission = mission;
			vm.onLoad();
		});
		DataService.loadMissionBoundary(vm.onLoad);
	};

	vm.onMapLoad = (map) => {
		if (vm.missionId) {
			DataService.loadMap(map).then((map) => {
				vm.map = map;
				vm.onLoad();
			});
		}
	};


	vm.clearSelected = () => {
		vm.selected = null;
		DataService.setMapOpts();
	};

	vm.toggleFullscreen = () => {
		vm.fullscreen = !vm.fullscreen;
		vm.resize();
	};

	vm.resize = () => {
		if (vm.map) {
			setTimeout(() => {
				google.maps.event.trigger(vm.map, "resize");
			});
		}
	};
}
